/* Pitch Eleven - selos: carrossel no mobile (um por vez, anel de progresso). */
if (!customElements.get('pe-trust')) {
  class PeTrust extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pe-trust__track');
      this.items = Array.from(this.querySelectorAll('.pe-trust__item'));
      this.dots = Array.from(this.querySelectorAll('.pe-trust__dot'));
      if (!this.track || this.items.length < 2 || this.dots.length === 0) return;

      this.index = 0;
      this.delay = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.mobile = window.matchMedia('(max-width: 1023px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = this.dataset.autoplay === 'true' && !this.reduced;

      this.onChange = () => this.refresh();
      this.mobile.addEventListener('change', this.onChange);

      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(parseInt(dot.dataset.go, 10))));

      let startX = null;
      this.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
      this.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
        startX = null;
      });

      this.onBlockSelect = (e) => {
        const item = e.target.closest?.('.pe-trust__item');
        if (item && this.contains(item)) this.go(this.items.indexOf(item), true);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      this.refresh();
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.mobile?.removeEventListener('change', this.onChange);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    refresh() {
      window.clearTimeout(this.timer);
      if (this.mobile.matches && this.autoplay) {
        this.classList.add('is-playing');
        this.go(this.index);
      } else {
        this.classList.remove('is-playing');
        this.go(this.index, true);
      }
    }

    go(i, semTimer) {
      const total = this.items.length;
      this.index = ((i % total) + total) % total;
      this.track.style.transform = this.mobile.matches ? `translateX(-${this.index * 100}%)` : '';
      this.items.forEach((item, n) => item.classList.toggle('is-active', n === this.index));
      this.dots.forEach((dot, n) => {
        dot.classList.remove('is-current');
        if (n === this.index) {
          void dot.offsetWidth;
          dot.classList.add('is-current');
        }
      });
      window.clearTimeout(this.timer);
      if (!semTimer && this.mobile.matches && this.autoplay) {
        this.timer = window.setTimeout(() => this.go(this.index + 1), this.delay);
      }
    }
  }

  customElements.define('pe-trust', PeTrust);
}
